import TourTooltip from './TourTooltip';

export default TourTooltip;
